import styled from "styled-components";
import media from "styled-media-query";

export const Container = styled.div`
  ${media.greaterThan("medium")`
    display: grid;
    grid-template-columns: 426px;
    align-items: center;
    height: 100%;
  `}
`;

export const Wrapper = styled.div`
  display: grid;
  grid-gap: 32px;
  height: fit-content;
  padding: 32px;
  width: 100%;

  ${media.greaterThan("medium")`
    padding: 48px;
  `}
`;

export const LoadingWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const Row = styled.div`
  display: grid;
  grid-gap: 24px;

  img {
    width: 40px;
  }
`;

export const Header = styled.div`
  display: grid;
  grid-gap: 4px;
  grid-template-rows: auto auto;
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.primary.prim50};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  ${({ theme }) => theme.font.heading.x};
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.neutral.gray8};
  font-weight: ${({ theme }) => theme.font.weight.regular};
  ${({ theme }) => theme.font.body.sm};
`;

export const ForgotPassword = styled.a`
  color: ${({ theme }) => theme.colors.primary.prim50};
  ${({ theme }) => theme.font.body.sm};
  text-decoration: none;

  cursor: pointer;
`;

export const BackToSite = styled.a`
  color: ${({ theme }) => theme.colors.neutral.gray8};
  ${({ theme }) => theme.font.body.sm};
  justify-self: center;
  text-decoration: none;

  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const Selector = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Image = styled.img`
  display: none;

  ${media.greaterThan("medium")`
    background-color: ${({ theme }) => theme.colors.primary.prim50};
    display: block;
    height: 100%;
    object-fit: contain;
    width: 100%;
  `}
`;
